import React from 'react'
import DecentralizedHero from './decentralisedHero/DecentralizedHero'
import DappEngage from './dappEngage/DappEngage';
import DappBusiness from './dappBusiness/DappBusiness';
import DappProcess from './dappProcess/DappProcess';
import DappBuild from './dappBuild/DappBuild';
import DappTestimonial from './dappTestmonial/DappTestimonial';
import DappService from './dappService/DappService';
import DappAccordion from './dappAccordion/DappAccordion';
import DappUse from './dappUse/DappUse';

export default function Decentralized() {
  return (
    <div>
        <DecentralizedHero/>
        <DappEngage/>
        <DappAccordion/>
        <DappBusiness/>
        <DappUse/>
        <DappProcess/>
        <DappBuild/>
        <DappTestimonial/>
        <DappService/>
    </div>
  )
}
